export class ProductDetailPayload {

  productId: string;
  lang: string;

  constructor(productId: string, lang: string) {
    this.productId = productId;
    this.lang = lang;
  }
}



// WEBPACK FOOTER //
// ./src/app/services/products/payload/product-detail.payload.ts